export const isEmailLike = (url: string) => url.includes('@');
export const isValidEmail = (input: string): boolean => /^(mailto:)*[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(input);
export const isValidURL = (url: string) => /^(ftp|http|https):\/\/[^ "]+\.[^ "]+$/.test(url);
const ALLOWED_PHONE_CHARS_REGEX = new RegExp(/^[0-9+()\- ]+$/);
export const hasValidPhoneCharacters = (input: string): boolean => ALLOWED_PHONE_CHARS_REGEX.test(input);
